export const formatDetailsBeforeSave = (detailsHTML: string): string => {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = detailsHTML

    const walk = (node: Node): string => {
        let output = ''

        node.childNodes.forEach((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
                output += (child as Text).textContent
            } else if (child.nodeType === Node.ELEMENT_NODE) {
                const tag = (child as HTMLElement).tagName.toLowerCase()

                if (tag === 'br') {
                    output += '\n'
                } else if (['div', 'p', 'section', 'article'].includes(tag)) {
                    output += walk(child) + '\n'
                } else {
                    output += walk(child)
                }
            }
        })

        return output
    }

    return walk(tempDiv)
        .replace(/\n{3,}/g, '\n\n')
        .trim()
}
